module.exports = "<html>\n  <body>\n    <p>Hi</p>\n  </body>\n</html>";